export class MedicalPrescriptionValidity {
  private Key: string;
  private UseType: string;
  private DaysValidity: number;

  setKey(value: string): void {
    this.Key = value;
  }

  getKey(): string {
    return this.Key;
  }

  setUseType(value: string): void {
    this.UseType = value;
  }

  getUseType(): string {
    return this.UseType;
  }

  setDaysValidity(value: number): void {
    this.DaysValidity = value;
  }

  getDaysValidity(): number {
    return this.DaysValidity;
  }
}
